// services/everpro/everpro-location/postal.ts — cek kodepos Everpro per-brand via S2 proxy
import { everproCache, brandKey } from './cache.js';

import { everproFetch } from '../everpro-auth';

export async function validatePostalCode(postalCode: string, brandId: string): Promise<any> {
  if (!brandId) throw new Error('Everpro: brandId wajib');
  const cacheKey = brandKey(brandId, postalCode);
  if (everproCache.postalCode.has(cacheKey)) return everproCache.postalCode.get(cacheKey);

  const res = await everproFetch(brandId, '/location/v1/postalcode', {
    method: 'POST',
    body: JSON.stringify({ postal_code: postalCode }),
  });

  if (!res.ok) {
    const text = await res.text();
    console.log(`[Everpro] Postal code ${postalCode} validation failed:`, text.slice(0, 200));
    throw new Error(`Postal code ${postalCode} not found in database (${res.status})`);
  }

  const json = await res.json();
  everproCache.postalCode.set(cacheKey, json.data);
  return json.data;
}

export async function resolveSubDistrictName(postalCode: string, brandId: string): Promise<string | null> {
  if (!postalCode || !brandId) return null;
  try {
    const data = await validatePostalCode(postalCode, brandId);
    const first = Array.isArray(data) ? data[0] : data;
    return first?.sub_district_name || null;
  } catch {
    return null;
  }
}
